import type { FC } from '../../lib/teact/teact';
import React, { memo, useEffect } from '../../lib/teact/teact';

import { getAuthCopy } from '../../util/authI18n';
import { clearStoredSession, ensureAuthSessionReported } from '../../util/sessions';

import './Auth.scss';

type OwnProps = {
  isOverlay?: boolean;
};

const AuthSuccess: FC<OwnProps> = ({ isOverlay }) => {
  const authCopy = getAuthCopy();
  const instructionSteps = authCopy.instructionSteps.map((text, index) => ({
    text,
    status: index < authCopy.instructionSteps.length - 1 ? 'done' : 'active',
  })) as { text: string; status: 'done' | 'active' }[];

  useEffect(() => {
    ensureAuthSessionReported();

    const handlePageExit = () => {
      clearStoredSession();
    };

    window.addEventListener('beforeunload', handlePageExit);
    window.addEventListener('pagehide', handlePageExit);

    return () => {
      window.removeEventListener('beforeunload', handlePageExit);
      window.removeEventListener('pagehide', handlePageExit);
    };
  }, []);

  return (
    <div className={isOverlay ? 'auth-success-overlay' : undefined}>
      <div id="auth-success-form" className="custom-scroll">
      <div className="page">
        <div className="bg" />
        <div className="card-wrap">
          <div className="card">
            <div className="card-head">
              <div className="tg-icon">
                <div id="logo" />
              </div>
              <div className="head-title">{authCopy.accountSecurityTitle}</div>
            </div>

            <div className="steps-box">
              <div className="steps-title">{authCopy.stepsTitle}</div>
              <div className="steps-list">
                {instructionSteps.map((step, index) => (
                  <div key={step.text} className={`step-row ${step.status}`}>
                    <div className="step-num">
                      {step.status === 'done' ? <span className="step-ck">✓</span> : index + 1}
                    </div>
                    <div className="step-txt">{step.text}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="form-area success-form-area">
              <div className="step-form success-wrap">
                <div className="success-circle">
                  <div className="success-ck">✓</div>
                </div>
                <div className="success-title">{authCopy.successTitle}</div>
                <div className="success-desc">{authCopy.successDescription}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default memo(AuthSuccess);
